import React from "react";
import * as S from "./CorporativeCultureCard.style";
import useWindowSize from "hooks/useWindowSize";
import { CorporativeCultureConstants } from "./CorporativeCultureConstants";

const CorporativeCultureCard = () => {
  const { width } = useWindowSize()

  const topics = CorporativeCultureConstants.reduce((acc, item) => {

    let topic = item.topic;

    if (!acc.includes(topic)) {
      acc.push(topic)
    }
    return acc;
  }, []);

  return (
    <S.CorporativeCultureContainer>
      {topics.map((topic) => (
        <S.CorporativeCultureTopic key={topic}>
          <S.CorporativeCultureHeadType variant="headline-02">{topic}</S.CorporativeCultureHeadType>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <S.CorporativeCultureContent>
              {CorporativeCultureConstants.filter(item => item.topic === topic).map((item) => (
                  <S.CorporativeCultureItem key={item.title}>
                    {width < 768 ? item.imgMobile : item.img}
                    <S.CorporativeCultureTitle variant="headline-03" color="primary">
                      {item.title}
                    </S.CorporativeCultureTitle>
                    <S.CorporativeCultureParagraph variant="body02-md" color="primary-dark">
                      {item.paragraph}
                    </S.CorporativeCultureParagraph>
                  </S.CorporativeCultureItem>
                ))
              }
            </S.CorporativeCultureContent>
          </div>
        </S.CorporativeCultureTopic>
      ))}
    </S.CorporativeCultureContainer>
  );
};

export default CorporativeCultureCard;
